import { ProcessManagerEnum } from '@fe/common/api/models/enums/ProcessManagerEnum'
import { getDefinedFields } from '@fe/common/utils/objectUtils'
import { SendData } from './RequestTypeSteps/stepsConfig'
import { MfaData } from 'src/components/MfaInput'

export const buildSendRequest = (
  formData: SendData,
  mfaData: MfaData | undefined
) => {
  const { amount_in, requestTypeFields, process_manager_id, ...restData } =
    formData

  return getDefinedFields({
    amount: amount_in,
    ...restData,
    ...requestTypeFields,
    ...mfaData,
    // The API takes the deferred order's id or no field; never a boolean (0 on the wire).
    process_manager_id: process_manager_id
      ? ProcessManagerEnum.StandingOrder
      : null,
  })
}
